import React, { Component } from 'react';

import {
    Link, Redirect
} from 'react-router-dom';
import {connect} from 'react-redux';
import {setting} from '../../actions/ValidateSetting';
import {Loader} from '../../components/Loader';

class Setting extends Component {
    constructor(props){
        super(props);
        this.branchData = this.props.data.branches;
		this.appData = this.props.data.apps ? this.props.data.apps : null;
		this.branch = this.props.branchId ? this.branchData.find(b => b.branch_id === this.props.branchId) : null;
		this.store = this.props.storeId ? this.branch.stores.find(s => s.store_id === this.props.storeId) : null;
		this.cashier = this.props.cashierId ? this.store.cashiers.find(c => c.cashier_id === this.props.cashierId) : null;
		this.state = {
			appId: this.props.appId || this.appData[0].id,
			appName: this.props.appId ? this.appData?.find(a => a.id === this.props.appId).name : this.appData[0].name,
			branchName: this.branch ? this.branch.name : this.branchData[0].name,
			storeName: this.store ? this.store.name : this.branchData[0].stores[0].name,
			cashierName: this.cashier ? this.cashier.name : this.branchData[0].stores[0].cashiers[0].name,
			branchId: this.props.branchId || this.branchData[0].branch_id,
			storeId: this.props.storeId || this.branchData[0].stores[0].store_id,
            cashierId: this.props.cashierId || this.branchData[0].stores[0].cashiers[0].cashier_id,
            payWaitConfirm: this.props.payWaitConfirm || this.branchData[0].stores[0].cashiers[0].payWaitConfirm,

            validatedSuccess: false,
            isSettingAccessible: this.props.settingData.isSettingAccessible
        };
        
    }

    handleEnterPress = e => {
        e.preventDefault();
        if( e.keyCode === 13 ){
            return this.handleConfirm();
        }
    }

    handleConfirm = (newToken) => {
        let content = this.state;
        let checkToken = {}
        if (typeof newToken?.token === 'string' && typeof newToken?.refresh_token === 'string') {
            checkToken.access_token = newToken.token 
            checkToken.refresh_token = newToken.refresh_token 
        } else {
            checkToken.access_token = this.props.token
            checkToken.refresh_token = this.props.data.refresh_token
        }

		this.props.dispatch(setting(content, checkToken));
	};

	setApp = (e) => {
        let pickedApp = this.appData.filter(app => app.id === e.target.value);
		if (pickedApp[0]?.id === this.state.appId) return null;
		this.setState({
			appName: pickedApp[0]?.name,
			appId: pickedApp[0]?.id
		})
	};

	setBranch = (e) => {
        let pickedBranch = this.branchData.filter(branch => branch.name === e.target.value);
		if (pickedBranch[0].branch_id === this.state.branchId) return null;
		this.setState({
			branchName: pickedBranch[0].name,
			branchId: pickedBranch[0].branch_id,
			storeName: pickedBranch[0].stores[0]?.name,
			storeId: pickedBranch[0].stores[0]?.store_id,
			cashierName: pickedBranch[0]?.stores[0]?.cashiers[0]?.name,
			cashierId: pickedBranch[0]?.stores[0]?.cashiers[0]?.cashier_id
		})
	};

	setStore = (e) => {
		let pickedBranch = this.branchData.filter(branch => branch.branch_id === this.state.branchId)
		let pickedStore = pickedBranch[0].stores.filter(store => store.name === e.target.value)
		if (pickedStore[0].store_id === this.state.storeId) return null
		this.setState({
			storeName: pickedStore[0].name,
			storeId: pickedStore[0].store_id,
			cashierName: pickedStore[0].cashiers[0]?.name,
			cashierId: pickedStore[0].cashiers[0]?.cashier_id
		})
	};

	setCashier = (e) => {
		let pickedBranch = this.branchData.filter(branch => branch.branch_id === this.state.branchId)
		let pickedStore = pickedBranch[0].stores.filter(store => store.store_id === this.state.storeId)
		let pickedCashier = pickedStore[0].cashiers.filter(cashier => cashier.name === e.target.value)

		if (pickedCashier[0].cashier_id === this.state.cashierId) return null
		this.setState({
			cashierName: pickedCashier[0].name,
            cashierId: pickedCashier[0].cashier_id,
            payWaitConfirm: pickedCashier[0].payWaitConfirm
		})
    };

    renderAppsPicker = () => {
		return this.appData?.map((a, id) =>
            <option key={a.id} value={a.id}>{a.name}</option>

		);
	};

	renderBranchesPicker = () => {
		return this.branchData.map((b, id) =>
            <option id={b.id} key={b.id} value={b.id}>{b.name}</option>
		);
	};

	renderStoresPicker = (branchIndex) => {
		return this.branchData[branchIndex].stores.map((s, id) =>
            <option id={s.local_id} key={s.id} value={s.id}>{s.name}</option>
		);
	};

	renderCashiersPicker = (branchIndex, storeIndex) => {
		return this.branchData[branchIndex]?.stores[storeIndex]?.cashiers?.map((c, id) =>
            <option id={c.local_id} key={c.id} value={c.id}>{c.name}</option>
		);
	};

    
    componentWillReceiveProps(nextProps) {
		if (nextProps.validateMessage) {
			return 
		}

        if (nextProps.token !== this.props.token) {
            this.handleConfirm(nextProps)
        }

		if (nextProps.isValidated && nextProps.isValidated !== this.props.isValidated) {
            return this.setState({
                validatedSuccess: true
            }, () => this.props.dispatch({type: "RESET_QUEUE"}))
		}
    }

    componentDidMount(){
        document.addEventListener('keyup', this.handleEnterPress)
    }

    componentWillUnmount(){
        document.removeEventListener('keyup', this.handleEnterPress)
    }

    render() {
        let {appId, branchName, storeName, cashierName, validatedSuccess, isSettingAccessible} = this.state;
        if(!isSettingAccessible) return <Redirect to='/passwordconfirm' />
        let {phone, data, isValidating,validateMessage} = this.props;
		let branchIndex = this.branchData.findIndex(branch => branch.branch_id === this.state.branchId);
		let storeIndex = this.branchData[branchIndex].stores.findIndex(store => store.store_id === this.state.storeId);
		let branchEnabled = this.branchData.length > 1;
		let storeEnabled = this.branchData[branchIndex].stores.length > 1;
		let cashierEnabled = this.branchData[branchIndex]?.stores[storeIndex]?.store_id.length > 1;
		let appEnabled = this.appData?.length > 1;
        let mcName = data.merchant && data.merchant.name ? data.merchant.name : this.state.appName;

        if(validatedSuccess) return <Redirect to='/home' />

        return (
            <React.Fragment>

            <div className="container mt-4 maxW-768">
                <div className="page-title text-center">Cài đặt cửa hàng</div>
                
                
                <div className="media mt-5">
                    <img className="mr-3" src="/cashier/shop/static/assets/images/logo-mc-default.svg" width="64" alt=""/>
                    <div className="media-body">
                        <div className="mc-name mt-2">{mcName}</div>
                        <span className="txtGray">{phone}</span>
                    </div>
                </div>
                
                <div className="mt-5 text-center">Chọn cửa hàng, quầy hàng nhận thông báo</div>

                {
                    validateMessage ? <div className="alert alert-danger fade show mt-4 mb-0 fs-s" role="alert">{validateMessage}</div> : null
                }
                
                <div className="row mt-5">
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Chọn ứng dụng</label>
                            <div className="customSelect">
                                <select ref={(e) => this.appSelect = e } value={appId} className="form-control" disabled={!appEnabled}
                                                    onChange={this.setApp}>
                                                {this.renderAppsPicker()}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Chọn chi nhánh</label>
                            <div className="customSelect">
                                <select ref={(e) => this.branchSelect = e} value={branchName} className="form-control" disabled={!branchEnabled}
                                                    onChange={this.setBranch}>
                                                {this.renderBranchesPicker()}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Chọn cửa hàng</label>
                            <div className="customSelect">
                                <select ref={(e) => this.storeSelect = e} value={storeName} className="form-control" disabled={!storeEnabled}
                                                    onChange={this.setStore}>
                                                {this.renderStoresPicker(branchIndex)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Chọn quầy hàng</label>
                            <div className="customSelect">
                                <select ref={(e) => this.cashierSelect = e} value={cashierName} className="form-control" disabled={!cashierEnabled}
                                                    onChange={this.setCashier}>
                                                {this.renderCashiersPicker(branchIndex, storeIndex)}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row mt-5 justify-content-center">
                    <div className="col-sm-4">
                        {
                            isValidating ? <Loader/> : 
                            <input type="button" className="btn btn-main w-100" value="XÁC NHẬN" 
                                onClick={this.handleConfirm} />
                        }
                    </div>
                </div>
            </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		phone: state.loginData.phone,
		data: state.loginData.result,
		token: state.loginData.token,
		refresh_token: state.loginData.refreshToken,
		isValidated: state.settingData.isValidated,
		isValidating: state.settingData.isValidating,
		validateMessage: state.settingData.message,
		branchId: state.settingData.branchId,
		storeId: state.settingData.storeId,
        cashierId: state.settingData.cashierId,
        payWaitConfirm: state.settingData.payWaitConfirm,
		appId: state.settingData.appId,
		settingData: state.settingData
	}
};

export default connect(mapStateToProps)(Setting);
